import * as z from "zod";

export const settingsFormSchema = (t: any) =>
  z.object({
    main_profile: z.object({
      main_profile_locale: z.string(),
    }),
    visibility: z.object({
      enable_public_profile: z.boolean().optional(),
      enable_workspace_join_via_url: z.boolean().optional(),
      profile_url_slug: z.string().min(5, t("forms:errors.slugMin")),
      enable_public_chat_on_profile_page: z.boolean().optional(),
    }),
    search_engine: z.array(z.string()).optional(),
  });

export type SettingsFormValues = z.infer<ReturnType<typeof settingsFormSchema>>;
